import React from 'react';
import {observer} from 'mobx-react';
import {getSensor} from '../request/dao';
import Header from './Header';
import TableView from './TableView';

@observer
class TemperatureCom extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        }
    }

    componentDidMount() {
        getSensor();
    }

    render() {
        const {SensorStore = {}} = this.props;
        const {sensors = []} = SensorStore;
        return (
            <section>
                <Header onSearch={(value) => this.setState({value})} />
                <TableView data={sensors} value={this.state.value} />
            </section>
        );
    }
}

export default TemperatureCom;
